export default __webpack_public_path__ + "75f024ce11d1fb961e8c4602e54a17a6.woff2";